module.exports = __webpack_public_path__ + "img/i-dialog.070a81d1.svg";